<template>
  <div class="photo-page">
    <div class="header-sticky">
      <div class="page-header">
        <div class="header-left">
          <h2>媒体</h2>
          <span class="header-sub" v-if="totalCount">图片 {{ imageCount }} · 视频 {{ videoCount }} · 语音 {{ voiceCount }}</span>
        </div>
        <div class="header-right" @click="showPicker=true">
          <span class="header-date">{{ selectedDate || '选择日期' }}</span>
          <van-icon name="calendar-o" size="20" color="#1989fa" />
        </div>
      </div>
      <div class="filter-bar">
        <span v-for="f in filters" :key="f.key" class="filter-chip" :class="{active:filterType===f.key}" @click="setFilter(f.key)">{{ f.label }}</span>
      </div>
    </div>

    <van-calendar v-model="showPicker" :min-date="minDate" :max-date="maxDate" :default-date="calDefaultDate"
      :show-confirm="false" :formatter="calendarFormatter" @select="onSelectDate" color="#1989fa">
      <template #title>
        <div class="cal-title-bar">
          <van-icon name="arrow-left" size="18" @click.stop="calYearShift(-1)"/>
          <span class="cal-year-text">{{ calYearText }}</span>
          <van-icon name="arrow" size="18" @click.stop="calYearShift(1)"/>
        </div>
      </template>
    </van-calendar>

    <div v-if="!years.length && !loading" class="empty-state">
      <van-icon name="photo-o" size="48" color="#c7c7cc"/>
      <p>暂无媒体</p>
    </div>

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="100" v-if="years.length">
    <div v-for="year in filteredYears" :key="year.year" class="year-section" :id="'year-'+year.year">
      <div class="year-header">{{ year.year }}年</div>
      <div v-for="month in year.months" :key="month.month" class="month-section" v-if="month.photos.length">
        <div class="month-header">{{ monthLabel(month.month) }}</div>
        <van-grid :column-num="3" :border="false" :gutter="1" :key="year.year+'-'+month.month">
          <van-grid-item v-for="(p, i) in month.photos" :key="p.date+p.src"
            @click="onMediaClick($event, p, year, month, i)">
            <div class="grid-inner">
              <van-image v-if="isImage(p) && p.thumb" :src="p.thumb" lazy-load fit="cover" class="photo-thumb" />
              <div v-else-if="isImage(p)" class="placeholder-cell">
                <van-icon name="photo-o" size="24" color="#c7c7cc"/>
              </div>
              <div v-else-if="p.type==='video' && p.thumb" class="video-thumb-wrap">
                <van-image :src="p.thumb" lazy-load fit="cover" class="photo-thumb" />
                <van-icon name="play-circle-o" size="22" color="rgba(255,255,255,.9)" class="video-play-icon"/>
              </div>
              <div v-else-if="p.type==='voice'" class="media-cell voice-cell">
                <van-icon name="music-o" size="24" color="#1989fa"/>
              </div>
              <div v-else class="media-cell video-cell">
                <van-icon name="video-o" size="24" color="#ff9500"/>
              </div>
              <div class="grid-overlay">
                <span class="grid-date-link">{{ fmtShort(p.date) }}</span>
              </div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    </van-list>

    <!-- 语音播放器 -->
    <van-popup v-model="showPlayer" position="bottom" round :style="{height:'auto',padding:'20px 16px 30px'}">
      <div class="player-header">
        <span class="player-title">语音播放</span>
        <van-icon name="close" size="20" color="#8e8e93" @click="stopAudio"/>
      </div>
      <div class="player-date" v-if="playingDate">{{ playingDate }}</div>
      <audio :src="playingSrc" ref="audioEl" controls autoplay class="audio-player"></audio>
    </van-popup>
  </div>
</template>

<script>
import { Grid, GridItem, ImagePreview, Icon, Calendar, Popup, Image, List } from "vant";

export default {
  components: {
    [Grid.name]: Grid, [GridItem.name]: GridItem,
    [Icon.name]: Icon, [Calendar.name]: Calendar, [Popup.name]: Popup,
    [Image.name]: Image,
    [List.name]: List
  },
  data() {
    return {
      years: [],
      pageNum: 1,
      loading: false,
      finished: false,
      showPicker: false,
      selectedDate: "",
      selectedDateStr: "",
      diaryDates: [],
      filterType: "all",
      filters: [
        { key: "all", label: "全部" },
        { key: "image", label: "图片" },
        { key: "voice", label: "语音" },
        { key: "video", label: "视频" }
      ],
      calDefaultDate: new Date(),
      showPlayer: false,
      playingSrc: "",
      playingDate: "",
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2099, 11, 31)
    };
  },
  computed: {
    filteredYears() {
      return this.years;
    },
    totalCount() {
      var n = 0;
      this.years.forEach(function(y) {
        y.months.forEach(function(m) { n += m.photos.length; });
      });
      return n;
    },
    imageCount() {
      var n = 0;
      this.years.forEach(function(y) {
        y.months.forEach(function(m) {
          m.photos.forEach(function(p) { if (p.type === 'image') n++; });
        });
      });
      return n;
    },
    videoCount() {
      var n = 0;
      this.years.forEach(function(y) {
        y.months.forEach(function(m) {
          m.photos.forEach(function(p) { if (p.type === 'video') n++; });
        });
      });
      return n;
    },
    voiceCount() {
      var n = 0;
      this.years.forEach(function(y) {
        y.months.forEach(function(m) {
          m.photos.forEach(function(p) { if (p.type === 'voice') n++; });
        });
      });
      return n;
    },
    calYearText() {
      return this.calDefaultDate.getFullYear() + "年";
    }
  },
  methods: {
    setFilter(key) {
      if (this.filterType === key) return;
      this.filterType = key;
      this.pageNum = 1;
      this.finished = false;
      this.years = [];
      this.loading = true;
      this.onLoad();
    },
    loadPhotos() {
      this.pageNum = 1;
      this.finished = false;
      this.years = [];
      this.onLoad();
    },
    onLoad() {
      var self = this;
      var params = { pageNum: this.pageNum++, pageSize: 50 };
      if (this.selectedDateStr) params.date = this.selectedDateStr;
      if (this.filterType !== 'all') params.type = this.filterType;
      this.$https.fetchPost("/diary/photos", params).then(function(r) {
        var data = r.data;
        var newList = data.list || [];
        self.mergePhotos(newList);
        self.loading = false;
        if (data.pageNumber >= data.totalPage) self.finished = true;
        if (self.pageNum === 2) self.loadDiaryDates(); // 仅首次加载后拉日期
      }).catch(function() { self.loading = false; });
    },
    mergePhotos(photos) {
      var self = this;
      photos.forEach(function(p) {
        var year = p.date.substring(0, 4);
        var month = p.date.substring(4, 6);
        var y = self.years.find(function(x) { return x.year === year; });
        if (!y) { y = { year: year, months: [] }; self.years.push(y); }
        var m = y.months.find(function(x) { return x.month === month; });
        if (!m) { m = { month: month, photos: [] }; y.months.push(m); }
        m.photos.push(p);
      });
    },
    loadDiaryDates() {
      var self = this;
      this.$https.fetchPost("/diary/dates", {}).then(function(r) {
        self.diaryDates = (r.data || []).map(function(x) { return String(x); });
      });
    },
    calendarFormatter(day) {
      var d = day.date;
      var y = d.getFullYear();
      var m = (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1);
      var dayStr = (d.getDate() < 10 ? "0" : "") + d.getDate();
      if (this.diaryDates.indexOf(y + m + dayStr) >= 0) {
        day.bottomInfo = "●";
      }
      return day;
    },
    calYearShift(n) {
      var d = new Date(this.calDefaultDate);
      d.setFullYear(d.getFullYear() + n);
      if (d < this.minDate) d = new Date(this.minDate);
      if (d > this.maxDate) d = new Date(this.maxDate);
      this.calDefaultDate = d;
    },
    onSelectDate(date) {
      this.showPicker = false;
      var y = date.getFullYear();
      var m = (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1);
      var d = date.getDate() < 10 ? "0" : date.getDate();
      var dateStr = y + "" + m + d;
      this.selectedDate = y + "年" + m + "月" + d + "日";
      this.selectedDateStr = dateStr;
      // 重新从该日期开始加载
      this.years = [];
      this.pageNum = 1;
      this.finished = false;
      this.onLoad();
    },
    monthLabel(m) {
      return parseInt(m) + "月";
    },
    allPhotos(year) {
      var arr = [];
      year.months.forEach(function(m) { arr = arr.concat(m.photos); });
      return arr;
    },
    isImage(p) { return p.type !== 'voice' && p.type !== 'video'; },
    onlyImages(year) {
      return this.allPhotos(year).filter(function(p) { return p.type !== 'voice' && p.type !== 'video'; });
    },
    imageIdx(year, month, i) {
      var photos = this.allPhotos(year);
      var target = month.photos[i];
      if (!this.isImage(target)) return -1;
      var n = 0;
      for (var j = 0; j < photos.length; j++) {
        if (photos[j] === target) return n;
        if (this.isImage(photos[j])) n++;
      }
      return -1;
    },
    stopAudio() {
      var el = this.$refs.audioEl;
      if (el) { el.pause(); el.currentTime = 0; }
      this.showPlayer = false;
    },
    onMediaClick(e, p, year, month, i) {
      var rect = e.currentTarget.getBoundingClientRect();
      var y = e.clientY - rect.top;
      var ratio = y / rect.height;

      // 下 1/3：跳转流水
      if (ratio > 0.66) {
        this.$router.push({ name: 'hist', query: { date: p.date } });
        return;
      }

      // 上 2/3：预览
      if (p.type === 'voice') {
        this.playingSrc = p.src;
        this.playingDate = this.fmtDate(p.date);
        this.showPlayer = true;
        return;
      }
      if (p.type === 'video') {
        window.open(p.src);
        return;
      }
      var imgs = this.onlyImages(year);
      var idx = this.imageIdx(year, month, i);
      if (idx >= 0) ImagePreview({ images: imgs.map(function(x) { return x.src; }), startPosition: idx });
    },
    preview(photos, idx) {
      var imgs = photos.map(function(p) { return p.src; });
      ImagePreview({ images: imgs, startPosition: idx });
    },
    fmtShort(d) {
      if (!d) return "";
      var s = String(d);
      return s.substring(4, 6) + "/" + s.substring(6, 8);
    },
    fmtDate(d) {
      if (!d) return "";
      var s = String(d);
      return s.substring(0, 4) + "年" + parseInt(s.substring(4, 6)) + "月" + parseInt(s.substring(6, 8)) + "日";
    }
  },
  mounted() {
    this.loadPhotos();
  }
};
</script>

<style lang="less" scoped>
.photo-page {
  min-height: 100vh;
  background: #fff;
}
.header-sticky {
  position: sticky;
  top: 0;
  z-index: 10;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 8px;
  background: rgba(255,255,255,.72);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);

  .header-left h2 {
    margin: 0 0 4px;
    font-size: 22px;
    font-weight: 700;
    color: #000;
  }
  .header-sub {
    font-size: 13px;
    color: #8e8e93;
    margin-top: 2px;
    display: block;
  }
  .header-right {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 20px;
    background: #f0f5ff;
    cursor: pointer;
  }
  .header-date {
    font-size: 13px;
    color: #1989fa;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.filter-bar {
  display: flex;
  gap: 8px;
  padding: 6px 16px 10px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
}
.filter-chip {
  flex-shrink: 0;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 500;
  color: #3c3c43;
  background: rgba(60,60,67,0.06);
  cursor: pointer;
  transition: all .2s ease;
  user-select: none;
  &:active { transform: scale(0.96); }
  &.active {
    color: #fff;
    background: #007aff;
  }
}
.year-section {
  margin-bottom: 16px;
}
.year-header {
  padding: 24px 12px 8px;
  font-size: 20px;
  font-weight: 700;
  color: #000;
}
.month-header {
  padding: 4px 12px 2px;
  font-size: 13px;
  font-weight: 600;
  color: #8e8e93;
}
.grid-inner {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.grid-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 33%;
  z-index: 2;
  background: linear-gradient(to top, rgba(0,0,0,.55) 0%, rgba(0,0,0,.2) 70%, transparent 100%);
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 0 0 6px 6px;
  pointer-events: none;
}
.grid-date-link {
  font-size: 10px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0,0,0,.5);
}
::v-deep .van-grid { padding: 0 !important; }
::v-deep .van-grid-item { overflow: hidden; }
::v-deep .van-grid-item__content { padding: 0 !important; }
::v-deep .van-grid-item__content { padding: 0 !important; }
.van-grid-item { aspect-ratio: 1; overflow: hidden; }
.photo-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.video-thumb-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  pointer-events: none;
  filter: drop-shadow(0 1px 3px rgba(0,0,0,.5));
}
.voice-cell,.placeholder-cell,.video-cell {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.voice-cell { background: #f0f5ff; }
.placeholder-cell { background: #f2f2f7; }
.voice-date {
  font-size: 10px;
  color: #1989fa;
  margin-top: 4px;
}
.empty-state {
  text-align: center;
  padding: 120px 0;
  color: #c7c7cc;
  font-size: 15px;
  p { margin-top: 12px; }
}
.safe-bottom { height: 50px; }
.cal-title-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 4px 0;
}
.cal-year-text {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  min-width: 80px;
  text-align: center;
}
.player-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.player-title {
  font-size: 17px;
  font-weight: 600;
}
.player-date {
  font-size: 13px;
  color: #8e8e93;
  margin-bottom: 12px;
}
.audio-player {
  width: 100%;
  outline: none;
}
::v-deep .van-calendar__bottom-info {
  color: #1989fa;
  font-size: 12px;
  font-weight: bold;
}
</style>
